import React, { useState, useEffect } from "react";
import graphqlRequest from "../../../requestMethod";
import { message } from "../../../components/Common/SnakeAlert/SnakeAlert";
import { useLocation } from "react-router-dom";
import "./EmailSubscriber.css";

const maskEmail = (email) => {
  if (!email) return "";
  const [name, domain] = email.split("@");
  const visible = name.slice(0, 3);
  return `${visible}${"*".repeat(name.length - 3)}@${domain}`;
};

const EmailSubscriber = () => {
  const [email, setEmail] = useState("");
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailParam = params.get("email");
    if (emailParam) setEmail(emailParam);
  }, [location]);

  const handleUnsubscribe = async () => {
    try {
      const query = `
        mutation {
          unsubscribeByEmail(email: "${email}")
        }
      `;

      const response = await graphqlRequest(query);
      const deletionMessage = response.data.unsubscribeByEmail;
      message.success(`${deletionMessage}`);
    } catch (error) {
      console.error("Error sending GraphQL request:", error);
      message.error("An error occurred while unsubscribing.");
    }
  };

  return (
    <div className="unsubscribe-wrapper">
      <img
        className="unsubscribe-logo"
        src="https://nurse-app-jobizo.s3.amazonaws.com/uploads/7ba3b58d-54d5-4d29-b553-48bfa5b92629.jobizologo"
        alt="Jobizo Logo"
      />

      <h2 className="unsubscribe-heading">Update email preferences for</h2>
      <p className="unsubscribe-email">{maskEmail(email)}</p>

      <div className="unsubscribe-button-container">
        <button
          className="unsubscribe-button"
          onClick={handleUnsubscribe}
          disabled={!email}
        >
          Unsubscribe from all emails
        </button>
      </div>

      <p className="unsubscribe-footer">
        If this is not your address, an email was most likely forwarded to you
        from someone else and you can safely ignore this message.
      </p>
    </div>
  );
};

export default EmailSubscriber;
